module.exports = __webpack_public_path__ + "static/media/0001.a75d86a4.jpg";